import { useEffect } from "react";
import { useUserAnalytics } from "@SeemplicityDev/shared";

export enum UserAnalyticsEvents {
  // eslint-disable-next-line no-unused-vars
  CLICK = "click",
}

const useEventTracker = (startTracking: boolean) => {
  const { trackEvent } = useUserAnalytics();

  useEffect(() => {
    if (startTracking) {
      Object.values(UserAnalyticsEvents).forEach((eventName) => {
        document.addEventListener(eventName, (event) => {
          handleTrackEvent(event, eventName);
        });
      });

      return () => {
        Object.values(UserAnalyticsEvents).forEach((eventName) => {
          document.removeEventListener(eventName, (event) => {
            handleTrackEvent(event, eventName);
          });
        });
      };
    }
  }, [startTracking]);

  const getEventElement = (event: Event, eventName: UserAnalyticsEvents) => {
    const target = event.target as HTMLElement;
    const mpEventName = `user_${eventName}`;
    return target.closest(`[data-analytics-event='${mpEventName}']`);
  };

  const getEventProps = (elementWithEvent: HTMLElement) => {
    if (!!elementWithEvent) {
      const eventProps = elementWithEvent.getAttribute("data-analytics-props");
      let eventPropsParsed = {};
      try {
        eventPropsParsed = JSON.parse(eventProps || "{}");
      } catch (error) {
        console.error(error);
      }
      return eventPropsParsed;
    }
    return {};
  };

  const handleTrackEvent = (event: Event, eventName: UserAnalyticsEvents) => {
    const element = getEventElement(event, eventName) as HTMLElement;
    if (!!element) {
      const eventProps = getEventProps(element);

      trackEvent(`user_${eventName}`, eventProps);
    }
  };
};

export default useEventTracker;
